import Input from "../Components/Modal/Input";
import { Modal } from "react-bootstrap";
import "../Styles/Modal.css";
import PasswordInput from "../Components/Modal/PasswordInput";
import { ButtonContainer } from "../Components/Shared/ButtonComponent";
import {  useState } from "react";

import Sex from "../Components/Modal/Sex";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../hooks/useAuth";


import styled from "styled-components";
import { toast, ToastContainer } from "react-toastify";

const StyledSpan = styled.span`
  font-size: 12px !important;
  translate: ${(props) =>
    props.country ? "0 2px" : props.password ? "0 -7px" : "0 -25px"};
  display: block;
  margin-left: 8px;
`;

function SignUpModal({ modalShow2, setModalShow, setModalShow2, ...props }) {
  const closeModalHandler = () => setModalShow2(false);
  const [signUpStep, setSignupStep] = useState(1);
  const [signupLoading, setSignupLoading] = useState(false);
  const { handleSignup } = useAuth();

  const toastOptions = {
    theme: "colored",
    position: "top-center",
    hideProgressBar: true,
  };

  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

  const SignUpSchema = Yup.object().shape({
    first_name: Yup.string().required("Please enter your first name"),
    last_name: Yup.string().required("Please enter your last name"),
    email: Yup.string()
      .required("Please enter your email")
      .email("Please enter a valid email"),
      phone_number: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required("Field is required"),
    password: Yup.string().required("Please enter a password"),
    sex: Yup.string().required("Please select a gender"),
  });

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      sex: "",
      phone_number: "",
    },
    onSubmit(values) {
      // console.log(values);
      setSignupLoading(true);
      handleSignup(values)
        .then((res) => {
          setModalShow2(false);
          setModalShow(true);
          toast.success("User created successfully", toastOptions);
        })
        .catch((err) => toast.error(`Error: ${err.message}`, toastOptions))
        .finally(() => {
          setSignupLoading(false);
        });
    },
    validationSchema: SignUpSchema,
  });

  // useEffect(() => {
  //   console.log(signupLoading);
  // }, [signupLoading]);

  return (
    <>
      <ToastContainer />
      <Modal
        dialogClassName={"SignUpModal"}
        show={modalShow2}
        // show={true}
        onHide={closeModalHandler}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <form onSubmit={formik.handleSubmit}>
          {signUpStep === 1 ? (
            <FirstStep
              {...{ setSignupStep, setModalShow2, setModalShow }}
              formik={formik}
            />
          ) : (
            <SecondStep
              {...{ setSignupStep, setModalShow2, setModalShow, signupLoading }}
              formik={formik}
            />
          )}
          <Modal.Footer>
            {/* <Button onClick={props.onHide}>Close</Button> */}
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}

export default SignUpModal;

const FirstStep = ({
  setSignupStep,
  setModalShow2,
  setModalShow,
  formik,
  ...restProps
}) => {
  const { touched, errors, getFieldProps } = formik;
  function goNextStep(e) { 
    setSignupStep(2);
  }
  return (
    <>
      <Modal.Header>
        <button
          onClick={() => {
            setModalShow2(false);
            setModalShow(true);
            setSignupStep(1);
          }}
          className="back_arrow"
        >
          <i className="fa-solid fa-arrow-left"></i>Back
        </button>
        <Modal.Title id="contained-modal-title-vcenter" className="modal-title">
          <h2>Signup</h2>
          <p>Enter your details to create your acount</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          <Input placeholder="First Name*" {...getFieldProps("first_name")} />
          {touched.first_name && errors.first_name && (
            <StyledSpan className="text-xs text-danger">
              {errors.first_name}
            </StyledSpan>
          )}
        </>
        <>
          <Input placeholder="Last Name*" {...getFieldProps("last_name")} />
          {touched.last_name && errors.last_name && (
            <StyledSpan className="text-xs text-danger">
              {errors.last_name}
            </StyledSpan>
          )}
        </>
        {/* <Input placeholder="Email Address*" /> */}
        <>
          <PasswordInput
            placeholder="Password*"
            {...getFieldProps("password")}
          />
          {touched.password && errors.password && (
            <StyledSpan password className="text-xs text-danger">
              {errors.password}
            </StyledSpan>
          )}
        </>
        {/* <Sex /> */}
        <ButtonContainer
          type="button"
          className="btn_continue"
          disabled={!formik.values.first_name || !formik.values.last_name || !formik.values.password}
          onClick={goNextStep}
        >
          Continue
        </ButtonContainer>

        <div className="account_signup">
          Already have an account?
          {/* <span>
            <Link to="">Sign Up</Link>{" "}
          </span> */}
          <button
            type="button"
            className="gf_btn"
            onClick={() => {
              setModalShow2(false);
              setModalShow(true);
            }}
          >
            Log In
          </button>
        </div>
      </Modal.Body>
    </>
  );
};

const SecondStep = ({
  setSignupStep,
  setModalShow2,
  setModalShow,
  formik,
  signupLoading,
  ...restProps
}) => {
  const {  touched, errors, getFieldProps } = formik;

  return (
    <>
      <Modal.Header closeButton>
        <button
          onClick={() => {
            setModalShow2(true);
            setSignupStep(1);
          }}
          className="back_arrow"
        >
          <i className="fa-solid fa-arrow-left"></i>Back
        </button>
        <Modal.Title id="contained-modal-title-vcenter" className="modal-title">
          <h2>Signup</h2>
          <p>Complete the following details to sign up</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          <Input placeholder="Email*" {...getFieldProps("email")} />
          {touched.email && errors.email && (
            <StyledSpan className="text-xs text-danger">
              {errors.email}
            </StyledSpan>
          )}
        </>
        <>
          <label className="country_label">Phone Number*</label>
          <Input placeholder="Phone*"  {...getFieldProps("phone_number")} />
          {touched.phone_number && errors.phone_number && (
            <StyledSpan country className="text-xs text-danger">
              {errors.phone_number}
            </StyledSpan>
          )}
        </>
        <>
          <Sex getFieldProps={formik.getFieldProps} />
          {touched.sex && errors.sex && (
            <StyledSpan sex className="text-xs text-danger">
              {errors.sex}
            </StyledSpan>
          )}
        </>
        <p className="terms_p">
          By signing up, you agree to the Terms & Conditions of 2m seamless
        </p>
        <ButtonContainer type="submit">
          {signupLoading ? (
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          ) : (
            "Complete"
          )}
        </ButtonContainer>
      </Modal.Body>
    </>
  );
};
